import type { HTMLAttributes } from "react";
import { cn } from "../lib/cn";

export interface SeparatorProps extends HTMLAttributes<HTMLDivElement> {
  orientation?: "horizontal" | "vertical";
  /**
   * `true` (padrão) = só linha visual, invisível para leitor de tela.
   * `false` = divisor semântico entre grupos de conteúdo.
   */
  decorative?: boolean;
  /** Divisor de seção usa a borda forte (DESIGN_SYSTEM seção 3). */
  strong?: boolean;
}

/**
 * Divisor. Prefira ele a "card dentro de card" — o anti-padrão da seção 12
 * é justamente empilhar bordas para separar micro-informação.
 */
export function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  strong = false,
  ...props
}: SeparatorProps) {
  return (
    <div
      role={decorative ? "presentation" : "separator"}
      aria-hidden={decorative ? "true" : undefined}
      aria-orientation={decorative ? undefined : orientation}
      className={cn(
        "shrink-0",
        strong ? "bg-border-strong" : "bg-border",
        orientation === "horizontal" ? "h-px w-full" : "h-full w-px",
        className,
      )}
      {...props}
    />
  );
}
